import React from 'react';
import PropTypes from 'prop-types';
import RadioSelect from 'components/radio_select';
import classNames from 'classnames';

import { storeAnswerToStorage } from '../storage_helpers';
import { trackQuestionAnswered } from '../tracking_helpers';

import QUESTIONS from '../constants/configurations';

const Tooltip = ({ questionKey }) => (
  <i aria-hidden="true" className="tip-on-hover relative question-tooltip padding-left-5px">
    <span className="tip d-none border padding-10px bg-white border-radius-5px box-shadow">
      <p className="text-tiny">{QUESTIONS[questionKey].tooltip}</p>
    </span>
  </i>
);

Tooltip.propTypes = {
  questionKey: PropTypes.string.isRequired,
};

class SurveyQuestion extends React.Component {
  dictToOptions = dict => {
    return Object.keys(dict).map(key => ({ label: dict[key], value: key }));
  };

  render() {
    const { questionKey, onAnswerSelected, isLP } = this.props;
    const onChange = ({ selectedOption, form }) => {
      const selectedOptionValue = selectedOption.value;
      storeAnswerToStorage(selectedOption.name, selectedOptionValue);
      form.setFieldValue(selectedOption.name, null);

      trackQuestionAnswered(selectedOption.name, selectedOptionValue);
      onAnswerSelected();
    };

    return (
      <div className="survey-question">
        <div className={classNames({ h4: isLP, h3: !isLP }, 'margin-bottom-20px')}>
          {QUESTIONS[questionKey].text}
          {QUESTIONS[questionKey].tooltip && <Tooltip questionKey={questionKey} />}
        </div>
        <RadioSelect
          formGroupClassName="padding-top-20px"
          formGroupLabel=""
          name={questionKey}
          onChange={onChange}
          options={this.dictToOptions(QUESTIONS[questionKey].answers)}
          radioLabelClassName="survey-answer-btn padding-left-20px width-100 padding-right-20px padding-left-sm-30px padding-right-sm-30px padding-top-15px padding-bottom-15px margin-bottom-15px"
          radioContainerClassName="square-buttons-container d-block"
        />
      </div>
    );
  }
}

SurveyQuestion.propTypes = {
  questionKey: PropTypes.string.isRequired,
  onAnswerSelected: PropTypes.func.isRequired,
  isLP: PropTypes.bool,
};

SurveyQuestion.defaultProps = {
  isLP: false,
};

export default SurveyQuestion;
